var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1228_3831",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1228_3831)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 18.3333C8.8484 18.3333 7.7655 18.1146 6.75132 17.6772C5.73714 17.2398 4.85498 16.6461 4.10483 15.8963C3.35468 15.1464 2.76075 14.2646 2.32303 13.2509C1.88546 12.2371 1.66667 11.154 1.66667 10.0015C1.66667 8.8489 1.88539 7.76549 2.32281 6.75131C2.76024 5.73713 3.35388 4.85497 4.10373 4.10482C4.85359 3.35468 5.73539 2.76074 6.74913 2.32302C7.76287 1.88545 8.84598 1.66666 9.99847 1.66666C11.1511 1.66666 12.2345 1.88545 13.2487 2.32302C14.2629 2.76045 15.145 3.35416 15.8952 4.10416C16.6453 4.85416 17.2393 5.73611 17.677 6.75C18.1146 7.76389 18.3333 8.84722 18.3333 10V11.0695C18.3333 11.8702 18.0584 12.5501 17.5086 13.109C16.9587 13.6679 16.2833 13.9474 15.4825 13.9474C14.9651 13.9474 14.4854 13.8208 14.0434 13.5678C13.6015 13.3147 13.2523 12.9666 12.9958 12.5235C12.6169 12.9757 12.1691 13.326 11.6524 13.5746C11.1356 13.8231 10.5848 13.9474 10 13.9474C8.90468 13.9474 7.97296 13.5633 7.20483 12.7952C6.4367 12.027 6.05264 11.0953 6.05264 10C6.05264 8.90468 6.4367 7.97295 7.20483 7.20482C7.97296 6.43669 8.90468 6.05263 10 6.05263C11.0953 6.05263 12.0271 6.43669 12.7952 7.20482C13.5633 7.97295 13.9474 8.90468 13.9474 10V11.0695C13.9474 11.5002 14.0955 11.8683 14.3919 12.1737C14.6882 12.4789 15.0518 12.6316 15.4825 12.6316C15.9132 12.6316 16.2767 12.4789 16.573 12.1737C16.8694 11.8683 17.0175 11.5002 17.0175 11.0695V10C17.0175 8.04093 16.3377 6.38158 14.9781 5.02193C13.6184 3.66228 11.9591 2.98245 10 2.98245C8.04094 2.98245 6.38158 3.66228 5.02194 5.02193C3.66229 6.38158 2.98246 8.04093 2.98246 10C2.98246 11.9591 3.66229 13.6184 5.02194 14.9781C6.38158 16.3377 8.04094 17.0175 10 17.0175H14.386V18.3333H10ZM10 12.6316C10.731 12.6316 11.3523 12.3757 11.864 11.864C12.3757 11.3523 12.6316 10.731 12.6316 10C12.6316 9.269 12.3757 8.64766 11.864 8.13596C11.3523 7.62427 10.731 7.36842 10 7.36842C9.26901 7.36842 8.64767 7.62427 8.13597 8.13596C7.62427 8.64766 7.36843 9.269 7.36843 10C7.36843 10.731 7.62427 11.3523 8.13597 11.864C8.64767 12.3757 9.26901 12.6316 10 12.6316Z",
    fill: "#57689F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/@.e5b4d010242239aee863de449911140b.svg";
export { ForwardRef as ReactComponent };